import React, { useState } from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope, 
  faUser, 
  faMessage,
  faLocationDot
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';


const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Show loading toast
    const loadingToast = toast.loading('Sending your message...');
    
    try {
      await axios.post(
        // 'http://localhost:3005/contact', 
        "https://afric-fresh-backend.onrender.com/contact",
        
        formData);
      
      // Dismiss loading toast and show success toast
      toast.dismiss(loadingToast);
      toast.success('Message sent successfully!', {
        duration: 4000,
        position: 'top-center',
        icon: '✅',
        style: {
          background: '#007D44',
          color: '#fff',
        },
      });

      // Clear form
      setFormData({ name: '', email: '', contact: '', message: '' });
      
    } catch (error) {
      // Dismiss loading toast and show error toast
      toast.dismiss(loadingToast);
      toast.error('Failed to send message. Please try again.', {
        duration: 4000,
        position: 'top-center',
        icon: '❌',
        style: {
          background: '#ff4444',
          color: '#fff',
        },
      });
      console.error('Error sending message:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  return (
    <div className="App bg-gray-50">
      <Navbar />
      <Toaster 
        toastOptions={{
          // Default options for all toasts
          style: {
            borderRadius: '10px',
            padding: '16px',
          },
          success: {
            iconTheme: {
              primary: '#fff',
              secondary: '#007D44',
            },
          },
        }}
      />
      <div className="max-w-6xl mx-auto p-6 lg:mt-[70px] mt-[130px]">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-[#007D44] mb-4">Get in Touch</h1>
          <p className="text-gray-600">We'd love to hear from you. Please fill out this form.</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

           {/* Contact Form */}
           <div className="bg-white rounded-3xl p-8 shadow-lg">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label 
                  htmlFor="name" 
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Full Name
                </label>
                <div className="relative">
                  <FontAwesomeIcon icon={faUser} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#007D44] focus:border-transparent"
                    placeholder="John Doe"
                    required
                  />
                </div>
              </div>

              <div>
                <label 
                  htmlFor="email" 
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Email Address
                </label>
                <div className="relative">
                  <FontAwesomeIcon icon={faEnvelope} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#007D44] focus:border-transparent"
                    placeholder="john@example.com"
                    required
                  />
                </div>
              </div>

              <div>
                <label 
                  htmlFor="contact" 
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Phone Number
                </label>
                <div className="relative">
                  <FontAwesomeIcon icon={faPhone} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="tel"
                    id="contact"
                    name="contact"
                    value={formData.contact}
                    onChange={handleChange}
                    className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#007D44] focus:border-transparent"
                    placeholder="+1 234 567 890"
                    required
                  />
                </div>
              </div>

              <div>
                <label 
                  htmlFor="message" 
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Your Message
                </label>
                <div className="relative">
                  <FontAwesomeIcon icon={faMessage} className="absolute left-4 top-4 text-gray-400" />
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={6}
                    className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#007D44] focus:border-transparent resize-none"
                    placeholder="Write your message here..."
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-[#007D44] text-white py-4 px-6 rounded-xl hover:bg-[#006435] transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#007D44] transform hover:scale-[0.99] active:scale-[0.97]"
              >
                Send Message
              </button>
            </form>
          </div>
          
          {/* Contact Information */}
          <div className="bg-[#007D44] rounded-3xl p-8 text-white">
            <h2 className="text-2xl font-bold mb-8">Contact Information</h2>
            
            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <FontAwesomeIcon icon={faPhone} className="text-xl" />
                </div>
                <div>
                  <p className="text-sm opacity-70">Call Us</p>
                  <p className="font-semibold">+1 346-209-6452</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <FontAwesomeIcon icon={faEnvelope} className="text-xl" />
                </div>
                <div>
                  <p className="text-sm opacity-70">Email Us</p>
                  <p className="font-semibold"> Me@africfresh.com</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <FontAwesomeIcon icon={faLocationDot} className="text-xl" />
                </div>
                <div>
                  <p className="text-sm opacity-70">Visit Us</p>
                  <p className="font-semibold">Houston, Texas.</p>
                </div>
              </div>
            </div>

            <div className="mt-12">
              <p className="font-semibold mb-4">Follow Us</p>
              <div className="flex space-x-4">
                {[
                  { icon: faFacebook, link: "https://facebook.com" },
                  { icon: faTwitter, link: "https://twitter.com" },
                  { icon: faInstagram, link: "https://instagram.com" },
                  { icon: faLinkedin, link: "https://linkedin.com" },
                  { icon: faWhatsapp, link: "https://whatsapp.com" }
                ].map((social, index) => (
                  <a
                    key={index}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors duration-300"
                  >
                    <FontAwesomeIcon icon={social.icon} className="text-lg" />
                  </a>
                ))}
              </div>
            </div>
          </div>

         
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactForm;